import { APP_LANGUAGES, DEFAULT_LOCALE } from '@core/constants';
import { Serializable } from '@core/models';
import { FrontGroup } from '@dynameat/models/frontGroup';

export class UserSettings extends Serializable {
  constructor(fteLanguage, role, roleLevel, availableFrontGroups) {
    super();
    this.language = fteLanguage;
    this.role = role;
    this.roleLevel = roleLevel;
    this.availableFrontGroups = availableFrontGroups;
  }

  serialize() {
    return {
      fte_language: this.language,
      role: this.role,
      role_level: this.roleLevel,
    };
  }

  static toInstance(props = {}) {
    let language;
    if (props.fte_language) {
      language = props.fte_language;
    } else {
      language = APP_LANGUAGES.find((lang) => navigator.language.includes(lang)) || DEFAULT_LOCALE || 'es';
    }
    const availableFrontGroups = FrontGroup.toInstanceList(props.available_front_groups);
    return new UserSettings(language, props.role, props.role_level, availableFrontGroups);
  }
}
